import { Record } from 'immutable'
import { FeedItemSourceType } from './enums'

export interface IFeedItemSource {
  id: string
  name: string
  type: FeedItemSourceType
}

const FeedItemSourceRecord = Record({
  id: '',
  name: '',
  type: FeedItemSourceType.Contact,
})

export class FeedItemSource extends FeedItemSourceRecord
  implements IFeedItemSource {
  public static fromJS(initialState?: Partial<IFeedItemSource>) {
    return new FeedItemSource(initialState)
  }

  public readonly id: string
  public readonly name: string
  public readonly type: FeedItemSourceType

  constructor(initialState?: Partial<FeedItemSource>) {
    initialState ? super(initialState) : super()
  }
}
